import React from "react";
import { useNavigate } from "react-router-dom";

interface FallbackUIProps {
  error: Error | null;
  componentStack: string | null;
}

const FallbackUI: React.FC<FallbackUIProps> = ({ error, componentStack }) => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/"); // Navigate to homepage
  };

  return (
    <div className="p-5 text-center h-full max-w-[800px] mx-auto flex flex-col items-center justify-center">
      <h1 className="font-semibold text-lg mb-3">Something Went Wrong!</h1>
      <p>
        We’re sorry, an unexpected error occurred. Our team has been notified.
      </p>

      {/* Display error message */}
      {error && (
        <div className="my-5 text-left">
          <h3>Error Details:</h3>
          <p>
            <strong>Message:</strong> {error.message || "Unknown error"}
          </p>
        </div>
      )}

      {/* Display component stack (optional, useful for debugging) */}
      {componentStack &&
        process.env.NODE_ENV !== "production" &&
        process.env.REACT_APP_ENVIRONMENT !== "production" && (
          <div className="my-5 text-left">
            <h3>Component Stack:</h3>
            <pre
              style={{
                whiteSpace: "pre-wrap",
                background: "#f5f5f5",
                padding: "10px",
                borderRadius: "4px",
              }}
            >
              {componentStack}
            </pre>
          </div>
        )}

      <button
        onClick={handleGoHome}
        className="px-[12px] w-fit py-[8px] bg-[#4338CA] text-white rounded-[6px] text-[16px] font-semibold flex flex-row items-center justify-center gap-[8px] shadow-[0px_2px_4px_0px_rgba(0,0,0,0.25)] mx-auto"
      >
        Back to Home
      </button>
    </div>
  );
};

export default FallbackUI;
